type Theme = 'light' | 'dark';

const THEME_STORAGE_KEY = 'app-theme';

// Aplicar tema no DOM usando CSS Variables
export const applyTheme = (theme: 'light' | 'dark'): void => {
  if (typeof window === 'undefined') return;
  
  const root = document.documentElement;
  
  // Remover classe dark
  root.classList.remove('dark');
  
  // Adicionar classe dark se necessário
  if (theme === 'dark') {
    root.classList.add('dark');
  }
  
  // Atualizar atributos
  root.setAttribute('data-theme', theme);
  root.style.colorScheme = theme;
  
  // Disparar evento customizado para notificar componentes
  window.dispatchEvent(new CustomEvent('themechange', { detail: { theme } }));
};

// Obter tema do localStorage
export const getTheme = (): Theme => {
  if (typeof window === 'undefined') return 'light';
  
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') {
      return stored as Theme;
    }
  } catch (error) {
    console.error('Erro ao ler tema do localStorage:', error);
  }
  
  return 'light';
};

// Salvar tema no localStorage
export const saveTheme = (theme: Theme): void => {
  if (typeof window === 'undefined') return;
  
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (error) {
    console.error('Erro ao salvar tema no localStorage:', error);
  }
};

// Definir tema (salva e aplica)
export const setTheme = (theme: Theme): void => {
  saveTheme(theme);
  applyTheme(theme);
};

// Alternar tema (apenas entre light e dark)
export const toggleTheme = (): Theme => {
  const current = getTheme();
  const newTheme: Theme = current === 'light' ? 'dark' : 'light';
  
  setTheme(newTheme);
  return newTheme;
};

// Inicializar tema (chamar no início da aplicação)
export const initTheme = (): void => {
  const theme = getTheme();
  applyTheme(theme);
};
